import React, { useState, useRef, useEffect } from "react";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sticky, setSticky] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [blockchainOpen, setBlockchainOpen] = useState(false);
  const [listingOpen, setListingOpen] = useState(false);
  const [marketingOpen, setMarketingOpen] = useState(false);
  const [mobileListing, setMobileListing] = useState(false);
  const [mobileMarketing, setMobileMarketing] = useState(false);
  const startX = useRef(0);

  // Sticky header
  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Swipe handlers
  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    if (endX - startX.current > 80) {
      setMobileOpen(false);
    }
  };

  return (
    <>
      <header className={`site-header ${sticky ? "solid" : "transparent"}`}>
        <div className="header-inner">
          <div className="logo">
            <a href="/">
              <img
                src={
                  sticky
                    ? "/assets/img/new_final_logo_xeer_horizontal.svg"
                    : "/assets/img/new_final_logo_xeer_horizontal_white.svg"
                }
                alt="logo"
              />
            </a>
          </div>

          <ul className="nav">
            <li
              className="nav-item"
              onMouseEnter={() => setSolutionsOpen(true)}
              onMouseLeave={() => setSolutionsOpen(false)}
            >
              <span className="nav-link">Solutions ▾</span>

              <div className={`megamenu ${solutionsOpen ? "show" : ""}`}>
                <div className="megamenu-box">
                  <div className="menu-col">
                    <h4>Exchange</h4>
                    <a href="/cryptocurrency-exchange">
                      Cryptocurrency Exchange
                    </a>
                    <a href="/decentralized-exchange">Decentralized Exchange</a>
                    <a href="/white-label-exchange">White Label Exchange</a>
                    <a href="/margin-trading-exchange">
                      Margin Trading Exchange
                    </a>
                    <a href="/security-exchange">Security Exchange</a>
                    <a href="/p2p-exchange">P2P Exchange</a>

                    <a href="/derivatives-exchange">Derivatives Exchange</a>
                    <a href="/arbitrage-trading-bots">Arbitrage Trading Bots</a>
                    <a href="/market-making-services">Market Making Services</a>
                  </div>

                  <div className="menu-col">
                    <h4>Wallet</h4>
                    <a href="/cryptocurrency-wallet">Cryptocurrency Wallet</a>
                    <a href="/web3-wallet">Web3 Wallet</a>
                    <a href="/crypto-wallet-clone">Crypto Wallet Clone App</a>
                    <a href="/nft-wallet">NFT Wallet</a>
                    <a href="/ethereum-wallet">Ethereum Wallet</a>
                    <a href="/bitcoin-wallet">Bitcoin Wallet</a>
                    <a href="/mobile-wallet-app">Mobile Wallet App</a>
                    <a href="/defi-wallet">Defi Wallet</a>
                    <a href="/white-label-wallet">White Label Wallet</a>
                  </div>

                  <div className="menu-col">
                    <h4>NFT Development</h4>
                    <a href="/nft-development">NFT Development</a>
                    <a href="/nft-collection-launch">NFT Collection Launch</a>
                    <a href="/nft-marketplace">NFT Marketplace</a>
                    <a href="/nft-loan">NFT Loan</a>
                    <a href="/nft-gaming">NFT Gaming Platform</a>
                    <div className="menu-col">
                      <h4>DeFi Development</h4>
                      <a href="/defi-development">DeFi Development</a>
                      <a href="/defi-staking">DeFi Staking</a>
                      <a href="/defi-lottery">DeFi Lottery</a>
                      <a href="/defi-lending-and-borrowing">
                        DeFi Lending And Borrowing
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <li
                className="nav-item"
                onMouseEnter={() => setBlockchainOpen(true)}
                onMouseLeave={() => setBlockchainOpen(false)}
              >
                <span className="nav-link">Blockchain ▾</span>

                <div className={`megamenu ${blockchainOpen ? "show" : ""}`}>
                  <div className="megamenu-box">
                    <div className="menu-col">
                      <h4>Blockchain Development</h4>
                      <a href="/blockchain-development">
                        Blockchain Development
                      </a>
                      <a href="/hashgraph-development">
                        Harshgraph Development
                      </a>
                      <a href="/blockchain-game-development">
                        Blockchain Game Development
                      </a>
                      <div className="menu-col pt-4">
                        <h4>Smart Contract</h4>
                        <a href="/smart-contract-development">
                          Smart Contract Development
                        </a>
                        <a href="/defi-smart-contract">DeFi Smart Contract</a>
                        <a href="/smart-contract-audit">Smart Contract Audit</a>
                      </div>
                    </div>

                    <div className="menu-col">
                      <h4>Blockchain Framework</h4>
                      <a href="/substrate">SubStrate</a>
                      <a href="/tezos">Tezos</a>
                      <a href="/cosmos">Cosmos</a>
                      <a href="/polygon-edge">Polygon Edge</a>
                      <a href="/polygon-blockchain">Polygon BlockChain</a>

                      <div className="menu-col pt-3">
                        <h4>Assent Tekenization</h4>
                        <a href="/assent-tekenization">Assent Tekenization</a>
                        <a href="/crypto-asset-management">
                          Crypto Asset Management
                        </a>
                      </div>
                    </div>

                    <div className="menu-col">
                      <h4>Layer 1 & 2 Solution</h4>
                      <a href="/bsc">BSC</a>
                      <a href="/ethereum">Ethereum</a>
                      <a href="/solana">Solana</a>
                      <a href="/cardano">Cardano</a>
                      <a href="/polkadot">Polkadot</a>
                      <a href="/ton">TON</a>
                      <div className="">
                        <a href="/enterprise-solutions">Enterprise Solutions</a>
                        <a href="/securitization">Securitization</a>
                        <a href="/p2p-lending">P2P Lending</a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </li>
            <li>
              <a className="nav-link" href="/ai-agent">
                AI Agent
              </a>
            </li>
            {/* <li
              className="nav-item simple-dropdown"
              onMouseEnter={() => setListingOpen(true)}
              onMouseLeave={() => setListingOpen(false)}
            >
              <span className="nav-link">Listing ▾</span>

              <ul className={`dropdown-menu ${listingOpen ? "show" : ""}`}>
                <li>
                  <a href="/exchange-listing">Exchange Listing</a>
                </li>
                <li>
                  <a href="/token-listing">Token Listing</a>
                </li>
                <li>
                  <a href="/coingecko-and-cmc-listing">
                    CoinGecko & CMC Listing
                  </a>
                </li>
              </ul>
            </li> */}
            <li>
              <a className="nav-link" href="/marketing">
                Marketing
              </a>
            </li>
            <li>
              <a className="nav-link" href="/case-studies">
                Case Studies
              </a>
            </li>
            <li>
              <a className="nav-link" href="/about-us">
                About Us
              </a>
            </li>
            {/* <li>
              <a className="nav-link" href="/contact-us">
                Contact Us
              </a>
            </li> */}

            <li>
              <a className="nav-link" href="#">
                Hire Developer
              </a>
            </li>
          </ul>

          <a href="#" className="cta-btn">
            Get Started ↗
          </a>

          {/* HAMBURGER */}
          <button className="hamburger" onClick={() => setMobileOpen(true)}>
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      <div
        className={`menu-overlay ${mobileOpen ? "show" : ""}`}
        onClick={() => setMobileOpen(false)}
      />

      {/* MOBILE MENU */}
      <div
        className={`mobile-menu ${mobileOpen ? "open" : ""}`}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div className="mobile-header">
          <img src="/assets/img/xeer_new_logo.svg" alt="logo" />
          <button className="close-btn" onClick={() => setMobileOpen(false)}>
            ✕
          </button>
        </div>

        <ul className="mobile-nav">
          <li
            className="mobile-parent"
            onClick={() => setSolutionsOpen(!solutionsOpen)}
          >
            Solutions
            <span className={solutionsOpen ? "rotate" : ""}>⌄</span>
          </li>

          <div className={`mobile-submenu ${solutionsOpen ? "show" : ""}`}>
            <h4>Exchange</h4>
            <a href="/cryptocurrency-exchange">Cryptocurrency Exchange</a>
            <a href="/white-label-exchange">White Label Exchange</a>
            <a href="/margin-trading-exchange">Margin Trading Exchange</a>
            <a href="/security-exchange">Security Exchange</a>
            <a href="/p2p-exchange">P2P Exchange</a>

            <a href="/derivatives-exchange">Derivatives Exchange</a>
            <a href="/arbitrage-trading-bots">Arbitrage Trading Bots</a>
            <a href="/market-making-services">Market Making Services</a>

            <h4>Wallet</h4>
            <a href="/cryptocurrency-wallet">Cryptocurrency Wallet</a>
            <a href="/web3-wallet">Web3 Wallet</a>
            <a href="/crypto-wallet-clone">Crypto Wallet Clone App</a>
            <a href="/nft-wallet">NFT Wallet</a>
            <a href="/ethereum-wallet">Ethereum Wallet</a>
            <a href="/bitcoin-wallet">Bitcoin Wallet</a>
            <a href="/mobile-wallet-app">Mobile Wallet App</a>
            <a href="/defi-wallet">Defi Wallet</a>
            <a href="/white-label-wallet">White Label Wallet</a>

            <h4>NFT Development</h4>
            <a href="/nft-development">NFT Development</a>
            <a href="/nft-collection-launch">NFT Collection Launch</a>
            <a href="/nft-marketplace">NFT Marketplace</a>
            <a href="/nft-loan">NFT Loan</a>
            <a href="/nft-gaming">NFT Gaming Platform</a>

            <h4>DeFi Development</h4>
            <a href="/defi-development">DeFi Development</a>
            <a href="/defi-staking">DeFi Staking</a>
            <a href="/defi-lottery">DeFi Lottery</a>
            <a href="/defi-lending-and-borrowing">DeFi Lending And Borrowing</a>
            <a href="/defi-yield-farming">DeFi Yield Farming</a>
          </div>

          <li
            className="mobile-parent"
            onClick={() => setBlockchainOpen(!blockchainOpen)}
          >
            Blockchain
            <span className={blockchainOpen ? "rotate" : ""}>⌄</span>
          </li>

          <div className={`mobile-submenu ${blockchainOpen ? "show" : ""}`}>
            <h4>Blockchain Development</h4>
            <a href="/blockchain-development">Blockchain Development</a>
            <a href="/hashgraph-development">Harshgraph Development</a>
            <a href="/blockchain-game-development">
              Blockchain Game Development
            </a>

            <h4>Blockchain Framework</h4>
            <a href="/substrate">SubStrate</a>
            <a href="/tezos">Tezos</a>
            <a href="/cosmos">Cosmos</a>
            <a href="/polygon-edge">Polygon Edge</a>
            <a href="/polygon-blockchain">Polygon BlockChain</a>

            <h4>Layer 1 & 2 Solution</h4>
            <a href="/bsc">BSC</a>
            <a href="/ethereum">Ethereum</a>
            <a href="/solana">Solana</a>
            <a href="/cardano">Cardano</a>
            <a href="/polkadot">Polkadot</a>
            <a href="/ton">TON</a>

            <h4>Smart Contract</h4>
            <a href="/smart-contract-development">Smart Contract Development</a>
            <a href="/defi-smart-contract">DeFi Smart Contract</a>
            <a href="/smart-contract-audit">Smart Contract Audit</a>

            <h4>Assent Tekenization</h4>
            <a href="/assent-tekenization">Assent Tekenization</a>
            <a href="/crypto-asset-management">Crypto Asset Management</a>

            <div>
              <a href="/enterprise-solutions">Enterprise Solutions</a>
              <a href="/securitization">Securitization</a>
              <a href="/p2p-lending">P2P Lending</a>
            </div>
          </div>

          {/* <li
            className="mobile-parent"
            onClick={() => setMobileListing(!mobileListing)}
          >
            Listing
            <span className={mobileListing ? "rotate" : ""}>⌄</span>
          </li>

          <div className={`mobile-submenu ${mobileListing ? "show" : ""}`}>
            <a href="/exchange-listing">Exchange Listing</a>
            <a href="/token-listing">Token Listing</a>
            <a href="/coingecko-and-cmc-listing">CoinGecko & CMC Listing</a>
          </div> */}
          <li>
            <a href="/marketing">Marketing</a>
          </li>
          <li>
            <a href="/case-studies">Case Studies</a>
          </li>
          <li>
            <a href="/about-us">About Us</a>
          </li>
          <li>
            <a href="/contact-us">Contact Us</a>
          </li>
          <li>
            <a href="#">Hire Developer</a>
          </li>
        </ul>
      </div>
    </>
  );
}
